"use client";
import { useState as g, useRef as z, useEffect as x } from "react";
import { useIsMounted as l } from "./use-is-mounted.js";
const w = {
  width: void 0,
  height: void 0
};
function B(t) {
  const { ref: e, box: i = "content-box" } = t, [{ width: v, height: a }, b] = g(w), s = l(), n = z({ ...w }), r = z(void 0);
  return r.current = t.onResize, x(() => {
    if (!e.current || typeof window > "u" || !("ResizeObserver" in window)) return;
    const u = new ResizeObserver(([d]) => {
      const h = i === "border-box" ? "borderBoxSize" : i === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize", o = S(d, h, "inlineSize"), c = S(d, h, "blockSize");
      if (n.current.width !== o || n.current.height !== c) {
        const f = { width: o, height: c };
        n.current.width = o, n.current.height = c, r.current ? r.current(f) : s() && b(f);
      }
    });
    return u.observe(e.current, { box: i }), () => {
      u.disconnect();
    };
  }, [i, e, s]), { width: v, height: a };
}
function S(t, e, i) {
  return t[e] ? Array.isArray(t[e]) ? t[e][0][i] : (
    // @ts-expect-error: TS doesn't know that box is a key of ResizeObserverEntry
    t[e][i]
  ) : e === "contentBoxSize" ? t.contentRect[i === "inlineSize" ? "width" : "height"] : void 0;
}
export {
  B as useResizeObserver
};
